module.exports = "https://www.niulinkcloud.com/_next/static/media/icon3.1aadaef3b70bef6655a6e7f67f495bc7.png";